import { useQuery } from '@tanstack/react-query'
import { societyQueries } from '../api/societies'

export const useUserBlockedInSociety = (
  societyId: string | undefined
): boolean => {
  const { data: userIsBlockedSocietyIds } = useQuery(
    societyQueries.getUserBlockedSocietyIds()
  )

  if (!societyId || !userIsBlockedSocietyIds) {
    return false
  }

  return userIsBlockedSocietyIds.includes(societyId)
}
